import Handlebars from 'injectify/runtime';
import {router} from '../../js/login/router';

Handlebars.registerHelper('localePath', function (path) {

    return router.getLocalePrefix() + path;
});



// WEBPACK FOOTER //
// ./shared/helper/localePathLogin.js